import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Modal,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import { Asterisk, X } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { fget, fpatch, fpost } from "../../API/callsAPI";
import commonStyles from "../../Utils/commonStyles";
import CreateOrEditCustomFieldModal from "../Settings/FieldTemplatesSettings/CreateOrEditCustomFieldModal";
import fieldTemplatesStyles from "../Settings/FieldTemplatesSettings/FieldTemplatesStyles";
import SingleFieldView from "../Settings/FieldTemplatesSettings/SingleFieldView";
import SingleTableView from "../Settings/FieldTemplatesSettings/SingleTableView";

const CreateOrEditCustomPageModal = ({
  type,
  projectId,
  handleClose,
  refreshData,
  setSnackValue,
  editData,
}) => {
  const classes = fieldTemplatesStyles();
  const commonClasses = commonStyles();
  const [isCreateNewFieldModalOpen, setIsCreateNewFieldModalOpen] =
    useState(false);
  const [defaultFields, setDefaultFields] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [pageName, setPageName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFieldsList, setSelectedFieldsList] = useState([]);
  
  const handleGetTemplates = async () => {
    try {
      let url = `trackables/trackable-field/?project=${projectId}`;
      if(editData.trackable){
        url+=`&trackable=${editData.trackable}`;
      }
      const res = await fget({
        url: url,
      });
      if(res && res.data) {
        const defaultFields = res.data.default_fields.map((field) => ({
          id: field.id,
          name: field.name,
          isRequired: field.required,
        }));
  
        setDefaultFields(defaultFields);
        setCustomFields(res.data.custom_fields);
        if(editData && editData.page_config){
          const selectedFields = [];
          Object.values(editData.page_config).forEach((fieldName) => {
            const defaultField = defaultFields.find((field) => field.name === fieldName);
            const customField = res.data.custom_fields.find((field) => field.name === fieldName);
            if (customField) {
              selectedFields.push(customField);
            }
            if(defaultField) {
              selectedFields.push(defaultField);
            }
          });

          setSelectedFieldsList(selectedFields);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetTemplates();
  }, [projectId]);

  const handleFieldClick = (field) => {
    if (selectedFieldsList?.length) {
      const isExist = selectedFieldsList?.some(
        (sin) => sin.name === field.name
      );
      if (isExist) {
        setSelectedFieldsList(
          selectedFieldsList.filter((sin) => sin.name !== field.name)
        );
      } else {
        setSelectedFieldsList([...selectedFieldsList, field]);
      }
    } else {
      setSelectedFieldsList([field]);
    }
  };

  const handleCreateNewPage = async () => {
    try {
      const addData = {
        url: `trackables/custom-page/`,
        data: {
          project: projectId,
          fields: selectedFieldsList?.map((item) => item.id),
          name: pageName,
          description,
        },
      };
      const res = await fpost(addData);
      if (res?.status === 200 || res?.status === 201) {
        setSnackValue({
          isOpen: true,
          message: `SuccessFully created new page`,
          isError: false,
        });
        refreshData();
        handleClose();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: "Error On creating custom page",
        isError: true,
      });
    }
  };
  const handleUpdatePage = async () => {
    const fieldids = selectedFieldsList
      ? selectedFieldsList.map((item) => item?.id).filter((id) => id != null || id != undefined)
      : [];
    const pageConfig = {};
    selectedFieldsList.forEach((field, index) => {
      pageConfig[index] = field.name || field.identifier;
    });
    try {
      const addData = {
        url: `trackables/custom-page/${editData.id}/`,
        data: {
          project: projectId,
          fields: fieldids,
          name: pageName,
          description,
          page_config: pageConfig,
        },
      };
      const res = await fpatch(addData);
      if (res?.status === 200 || res?.status === 201) {
        setSnackValue({
          isOpen: true,
          message: `SuccessFully edited page`,
          isError: false,
        });
        refreshData();
        handleClose();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: "Error On editing custom page",
        isError: true,
      });
    }
  };

  useEffect(() => {
    if (editData) {
      setPageName(editData.name);
      setDescription(editData.description);   
    }
  }, [editData, type]);

  return (
    <Card
      sx={{
        width: {
          md: "800px",
          lg: "1000px",
          xl: "1200px",
        },
        backgroundColor: "#1B1D28",
        color: "white",
        borderRadius: "20px",
        padding: "10px",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Box className={commonClasses.flexBetween}>
          <Typography sx={{ fontSize: "20px !important", fontWeight: 600 }}>
            {type === "new" ? "Create New Page" : "Edit Page"}
          </Typography>
          <Button
            sx={{ padding: 0, minWidth: 0, color: "white" }}
            onClick={handleClose}
          >
            <X size={20} />
          </Button>
        </Box>
        <Box className={commonClasses.flexAndGap8Px}>
          <Box width="100%">
            <Box display="flex" alignItems="center" gap="6px">
              <Typography>Page Name</Typography>
              <Asterisk color="red" />
            </Box>
            <Box
              style={{ marginTop: "5px" }}
              className={classes.cardContentDiv3}
            >
              <TextField
                value={pageName}
                onChange={(e) => setPageName(e.target.value)}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: "6px",
                    backgroundColor: "transparent",
                    color: "white !important",
                    opacity: 1,
                    fontSize: "16px",
                    fontFamily: "poppins",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    "& fieldset": {
                      borderColor: "transparent",
                    },
                    "&:hover fieldset": {
                      borderColor: "transparent",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "transparent",
                    },
                  },
                  "&.Mui-disabled .MuiInputBase-input": {
                    color: "gray",
                  },
                }}
                fullWidth
              />
            </Box>
          </Box>
          <Box width="100%">
            <Box display="flex" alignItems="center" gap="6px">
              <Typography>Description</Typography>
            </Box>
            <Box
              style={{ marginTop: "5px" }}
              className={classes.cardContentDiv3}
            >
              <TextField
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: "6px",
                    backgroundColor: "transparent",
                    color: "white !important",
                    opacity: 1,
                    fontSize: "16px",
                    fontFamily: "poppins",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    "& fieldset": {
                      borderColor: "transparent",
                    },
                    "&:hover fieldset": {
                      borderColor: "transparent",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "transparent",
                    },
                  },
                  "&.Mui-disabled .MuiInputBase-input": {
                    color: "gray",
                  },
                }}
                fullWidth
              />
            </Box>
          </Box>
        </Box>
        <Box>
        <Typography
          sx={{ mb: 2, fontSize: "14px", color: "rgba(255,255,255,0.7)" }}
        >
          Available columns from this row type:
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(5, 1fr)",
            },
            gap: "12px",
          }}
        >
          {defaultFields.map((field) => (
            <FormControlLabel
              key={`default-${field.name}`}
              control={
                <Checkbox
                  checked={selectedFieldsList?.some((sin) => sin.name === field.name)}
                  onChange={() => handleFieldClick(field)}
                  sx={{
                    color: "#606479",
                    "&.Mui-checked": {
                      color: "#6C65D9",
                    },
                  }}
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <Typography sx={{ fontSize: "14px", color: "white" }}>
                    {field.name}
                  </Typography>
                  {field.isRequired && (
                    <Typography sx={{ fontSize: "14px", color: "#FF6B6B" }}>
                      *
                    </Typography>
                  )}
                </Box>
              }
              sx={{
                backgroundColor: "#252A38",
                borderRadius: "8px",
                padding: "8px 12px",
                margin: 0,
                "& .MuiFormControlLabel-label": {
                  width: "100%",
                },
              }}
            />
          ))}
        </Box>
      </Box>
        <Box>
          <SingleFieldView
            title="Custom Fields"
            showAddIcon={true}
            handleAddNew={() => setIsCreateNewFieldModalOpen(true)}
            fields={customFields}
            type="custom"
            onFieldClick={handleFieldClick}
            selectedFields={selectedFieldsList}
            handleGetTemplates={handleGetTemplates}
          />
        </Box>
        <SingleTableView items={selectedFieldsList ?? []} onReorder={(newOrder) => setSelectedFieldsList(newOrder)} />
        <CardActions className={commonClasses.flexCenter}>
          <Button
            onClick={() => {
              type === "new" ? handleCreateNewPage() : handleUpdatePage();
            }}
            variant="contained"
            sx={{
              backgroundColor: "#6C65D9",
              borderRadius: "10px",
              textTransform: "none",
              "&:disabled": {
                backgroundColor: "#6C65D9",
                color: "gray",
              },
            }}
            disabled={!pageName || selectedFieldsList.length === 0}
          >
            <Typography>{type === "new" ? "Create" : "Update"} Page</Typography>
          </Button>
        </CardActions>
      </CardContent>
      <Modal
        open={isCreateNewFieldModalOpen}
        onClose={() => setIsCreateNewFieldModalOpen(false)}
        className={commonClasses.flexCenter}
      >
        <CreateOrEditCustomFieldModal
          type="new"
          handleClose={() => setIsCreateNewFieldModalOpen(false)}
          projectId={projectId}
          updateRefreshCounter={handleGetTemplates}
          selectedTrackable={null}
        />
      </Modal>
    </Card>
  );
};

export default CreateOrEditCustomPageModal;
